import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ApproveRedelegation } from '../../../interface/temporaryredelegation/approveredelegation';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { MaterialModule } from '../../../shared/module/material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RoleService } from '../../../shared/services/RoleService';
import { SharedServices } from '../../../shared/services/shared.services';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-approveredelegation',
  imports: [MaterialModule, CommonModule, FormsModule, RouterOutlet,MatProgressSpinnerModule],
  templateUrl: './approveredelegation.component.html',
  styleUrls: ['./approveredelegation.component.css']
})
export class ApproveredelegationComponent implements OnInit {
  showParentContent: boolean = true;
  displayedColumns: string[] = ['sno', 'name', 'jobTitle', 'reasons', 'enteredDate', 'approver', 'status'];
  dataSource!: MatTableDataSource<ApproveRedelegation>;
  recordsPerPage: number = 10;
  noDataMessage : string = "";
  public paginator!: MatPaginator;
  isLoading: boolean = true;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    private redelegationService: TemporaryRedelegationService,
    private router: Router,
    private route: ActivatedRoute,
    private roleService: RoleService,
    private sharedService: SharedServices
  ) {}

  ngOnInit(): void {
    this.redelegationService.getRedelegations().subscribe({
      next: (data) => {
        const loggedUserEmail = this.sharedService.getloggedUserEmail();
        let filteredData = data.filter(item => item.approverEmail?.toUpperCase() === loggedUserEmail.toUpperCase());
        this.roleService.fetchUserRoles().subscribe({
          next: (roles) => {
            if (roles && roles.some(role => ['A', 'U'].includes(role.trim()))) {
              filteredData = data;
            }
            this.dataSource = new MatTableDataSource(filteredData);
            this.setDataSourceAttributes();
            this.isLoading = false;
            if (this.dataSource.data.length === 0) {
              this.noDataMessage = "No Temporary Re-Delegation of Authority Request found!";
            } else {
              this.noDataMessage = "";
            }
          },
           error: () => {
          this.dataSource = new MatTableDataSource(filteredData);
          this.setDataSourceAttributes();
          this.isLoading = false;
          }
        });
      },
      error: () => {
        this.isLoading = false;
        this.noDataMessage = "Error fetching delegations.";
      }
    });
    // Subscribe to route changes to determine if the current route is a child route
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.showParentContent = !this.router.url.includes('Redelegation?FromEmpno');
    });
  }

  setDataSourceAttributes() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
    }
  }

  onPageChange(event: PageEvent): void {
    this.recordsPerPage = event.pageSize;
    this.dataSource.paginator = this.paginator;
  }

  getReq(FromEmpno: string, eDate: string): void {
    // Implement the logic to handle the click event
    // Example: navigate to another route with parameters
    this.router.navigate(['/TemporaryRedelegation/Redelegation'], { queryParams: { FromEmpno, eDate }, relativeTo: this.route });
  }
  formatDateTo(dateString: string): string {
    if (!dateString) {
      return "";
  }
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    const strTime = hours.toString().padStart(2, '0') + ':' + minutes + ' ' + ampm;

    return `${day}-${month}-${year} ${strTime}`;
}
applyFilter(event: Event, column: string): void {
  const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
  this.dataSource.filterPredicate = (data: ApproveRedelegation, filter: string) => {
    const filters = JSON.parse(filter);
    return Object.keys(filters).every(key => {
      if (key === 'enteredDate') {
        const formattedDate = this.formatDateTo(data.enteredDate).toLowerCase();
        return formattedDate.includes(filters[key]);
      } else {
        const textToSearch = data[key as keyof ApproveRedelegation] && data[key as keyof ApproveRedelegation].toString().toLowerCase() || '';
        return textToSearch.indexOf(filters[key]) !== -1;
      }
    });
  };
 
  const currentFilters = this.dataSource.filter ? JSON.parse(this.dataSource.filter) : {};
  currentFilters[column] = filterValue;
  this.dataSource.filter = JSON.stringify(currentFilters);
}
}
